var CollectionView = require('views/base/collection-view');

var PortfolioView = CollectionView.extend({
  autoRender: true,
  template: require('./templates/portfolio'),
  listSelector: '.portfolio-tab-content',
  getTemplateData: Chaplin.View.prototype.getTemplateData,
  initialize: function () {
    var self = this;
    this.collection.models[0].set('first', true);
    this.on('addedToDOM', function () {
      self.$('.portfolio-content').focus();
    });
    CollectionView.prototype.initialize.apply(this, arguments);
  },
  load: function(){
    this.$('.portfolio-content').focus();
  },
  initItemView: function(model) {
    var ItemViewType = require('views/portfolio/' + model.get('type') + '/' + model.get('type') + '-view');

    return new ItemViewType({
      model: model
    });
  }
});

module.exports = PortfolioView;
